import { SVGProps } from 'react';

const CircleDashed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.1 2.182a10 10 0 0 1 3.8 0m0 19.636a10 10 0 0 1-3.8 0m7.509-18.097a10 10 0 0 1 2.69 2.7m-18.117 7.48a10 10 0 0 1 0-3.8m18.097 7.508a10 10 0 0 1-2.7 2.69M21.818 10.1a10 10 0 0 1 0 3.8M3.721 6.39a10 10 0 0 1 2.7-2.69m-.03 16.58a10 10 0 0 1-2.69-2.7"
    />
  </svg>
);
export default CircleDashed;
